import { render, staticRenderFns } from "./management-library-electronic-storage-category-form.vue?vue&type=template&id=afad0a56"
import script from "./management-library-electronic-storage-category-form.vue?vue&type=script&lang=js"
export * from "./management-library-electronic-storage-category-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports